import React from 'react';

import { accountListSelector, useAccounts } from '../../../../fetchHooks/useAccount';
import { ErrorView } from '../../../AccountOverview/components';
import { AccountsOverviewContent } from '../AccountsOverviewContent';
import { AccountsOverviewLoader } from '../AccountsOverviewLoader';

export const SingleAccountsList = () => {
    const { data: accounts, error, isLoading, isRefetching, refetch } = useAccounts({ select: accountListSelector });

    if (error) {
        return <ErrorView error={error} refresh={refetch} />;
    }

    const loading = isLoading || isRefetching;

    if (loading || accounts === undefined) {
        return <AccountsOverviewLoader accounts={accounts} />;
    }

    return <AccountsOverviewContent accounts={accounts} />;
};
